import { Box, Button } from "@material-ui/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNotify } from "react-admin";

import CustomCard from "../../../components/CustomCard";
import Loader from "../../../components/Loader";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useDisabledOnLoading from "../../../hooks/useDisabledOnLoading";
import { gymDocRef } from "../../../utils/referencies";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import LocalizedRichText from "../../Settings/LocalizedRichText";

const GymManagement = () => {
  const notify = useNotify();
  const { user } = useCurrentUser();
  const [userData, setUserData] = useState<any>(null);
  const [facilitiesHasError, setFacilitiesHasError] = useState(false);
  const [activitiesHasError, setActivitiesHasError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { disabledStyles } = useDisabledOnLoading(loadingSubmit);

  const activities = useRef({ en: "", ar: "" });
  const facilities = useRef({ en: "", ar: "" });

  const fetchUserData = async () => {
    try {
      const snapshot = await gymDocRef(user.id!).get();
      if (snapshot.exists) {
        setUserData(snapshot.data());
      }
      setLoading(false);
    } catch (ex: any) {
      console.log(ex.message);
      setLoading(false);
    }
  };

  const handleFacilitiesChange = useCallback((value: any) => {
    facilities.current = value;
  }, []);

  const handleActivitiesChange = useCallback((value: any) => {
    activities.current = value;
  }, []);

  const handleSubmit = async () => {
    setLoadingSubmit(true);
    try {
      console.log(
        applyUpdateTimestamp({
          facilities: facilities.current,
          activities: activities.current,
        })
      );
      await gymDocRef(user.id!).update(
        applyUpdateTimestamp({
          facilities: facilities.current,
          activities: activities.current,
        })
      );
      setLoadingSubmit(false);
      notify("Updated successfully", "success");
    } catch (ex: any) {
      console.log(ex.message);
      setLoadingSubmit(false);
      notify("Error on updating", "error");
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <Loader loading={loading}>
      {userData ? (
        <Box style={disabledStyles}>
          <CustomCard title="Activities" width="50%">
            <LocalizedRichText
              onChange={handleActivitiesChange}
              hasError={(error) => {
                setActivitiesHasError(error);
              }}
              initialValue={userData.activities}
            />
          </CustomCard>

          <CustomCard title="Facilities" width="50%">
            <LocalizedRichText
              onChange={handleFacilitiesChange}
              hasError={(error) => {
                setFacilitiesHasError(error);
              }}
              initialValue={userData.facilities}
            />
          </CustomCard>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={facilitiesHasError || activitiesHasError}
          >
            Submit
          </Button>
        </Box>
      ) : null}
    </Loader>
  );
};

export default GymManagement;
